/**
 * Utility for managing GitHub API token in localStorage
 */

const TOKEN_STORAGE_KEY = 'github_api_token';

/**
 * Get saved GitHub API token
 * @returns {string}
 */
export const getSavedToken = () => {
  try {
    return localStorage.getItem(TOKEN_STORAGE_KEY) || '';
  } catch (error) {
    console.error('Error reading saved token:', error);
    return '';
  }
};

/**
 * Save GitHub API token
 * @param {string} token - GitHub API token to save
 */
export const saveToken = (token) => {
  try {
    if (token && token.trim() !== '') {
      localStorage.setItem(TOKEN_STORAGE_KEY, token);
    }
  } catch (error) {
    console.error('Error saving token:', error);
  }
};

/**
 * Clear saved GitHub API token
 */
export const clearToken = () => {
  try {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing token:', error);
  }
};
